import axios from 'axios';

import { API_BASE_URL } from 'src/common/constants';

export default class SubscriptionService {
    static instance;
    resource = `${API_BASE_URL}/subscription/subscriptions`;

    static getInstance() {
        if (!SubscriptionService.instance) {
            SubscriptionService.instance = new SubscriptionService();
        }

        return SubscriptionService.instance;
    }

    async fetchSubscriptionDetail(subscriptionId, params = {}) {
        const response = await axios.get(
            `${this.resource}/${subscriptionId}`,
            {
                params: params,
                headers: {
                    Authorization: `Bearer ${localStorage.getItem(
                        "LOCAL_STORAGE_KEY_ACCESS_TOKEN"
                    )}`
                }
            }
        );

        return response.data.data
    }

    async sendCancelSubscriptionRequest(subscriptionId, payload = {}) {
        const response = await axios.post(
            `${this.resource}/${subscriptionId}/cancel`,
            payload,
            {
                params: {},
                headers: {
                    Authorization: `Bearer ${window.localStorage.getItem(
                        'LOCAL_STORAGE_KEY_ACCESS_TOKEN'
                    )}`
                }
            }
        )

        return response.data.data
    }
}
